import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import FormulaValue from "../../../components/formula-value";
import FormulaName from "../../../components/formula-name";
import { batchRequest } from '../../../../../api/ApiService';
import { Loader } from 'react-loaders';
import AbbreviatedMillionNumberFormat from "../../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class RoeStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      averageTotalEquity: 0,
      totalEquity: 0,
      netIncome: 0,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;
    const prevRound = rounds.find(i => i.number === activeRound - 1);
    const prevRoundId = prevRound ? prevRound.id : 0;

    batchRequest([
      `${process.env.REACT_APP_API_URL}team/report/balance_sheet/?round_lte=${activeRound}`,
      `${process.env.REACT_APP_API_URL}team/report/income_statement/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}v2/games/targets/`,
    ])
      .then(res => {
        const balanceSheet = res[0].body;
        const currentRoundBalanceSheet = balanceSheet.find(i => i.round === roundId);
        const prevRoundBalanceSheet = balanceSheet.find(i => i.round === prevRoundId);

        let totalEquity = currentRoundBalanceSheet ? Number(currentRoundBalanceSheet['Total Equity'] || 0) : 0;
        if (prevRoundBalanceSheet) {
          const prevTotalEquity = Number(prevRoundBalanceSheet['Total Equity'] || 0);
          totalEquity = (totalEquity + prevTotalEquity) / 2;
        }

        const incomeStatement = res[1].body;
        const currentRoundIncomeStatement = incomeStatement.find(i => i.round === roundId);
        const netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;

        const targets = res[2].body;
        const currentRoundTargets = targets.find(i => i.round_number === activeRound);
        const roeTarget = currentRoundTargets ? Number(currentRoundTargets.roe || 0) : 0;

        this.setState({
          loaded: true,
          averageTotalEquity: totalEquity * roeTarget,
          totalEquity,
          netIncome: netIncome,
        })
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      averageTotalEquity,
      totalEquity,
      netIncome,
    } = this.state;
    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="ROE"
        previousShownErrors={previousShownErrors}
        alertText="Your net profit was not enough."
        paragraph2={(
          <Fragment>
            Given your average total equity, your company needed to generate <b>${Number((averageTotalEquity / 1000000).toFixed(2))}M</b> in
            net profits in order to hit your ROE target.
          </Fragment>
        )}
        visual={(
          <Fragment>
            <FormulaName background="#a98df6">
              Return on Equity<br />
              (ROE)
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Net Profits
              <span className='divider' />
              Average Total Equity
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>

            <FormulaValue>
              <AbbreviatedMillionNumberFormat
                value={netIncome}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
              <span className='divider' />
              <AbbreviatedMillionNumberFormat
                value={totalEquity}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#d5d9dd',
          background: '#eae4f9',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default RoeStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/roe/step2.js